/**
 *
 * Asynchronously loads the component for ClientProtfolio
 *
 */

import { lazyLoad } from 'utils/loadable';

export const ClientProtfolio = lazyLoad(
  () => import('./index'),
  module => module.ClientPortfolio,
);
